import React from 'react'
import login_img from '../../Assets/Images/driving_guide3.png'
const AccountContainer = ({ children }) => {

    return (
        <div className='login-image-box'>
            <div className="login-admin">
                <div className='row align-items-center mx-0'>
                    <div className="col-md-6 left-login-image">
                        <div>
                            <h1 className='display-1 fw-semibold text-white'>
                                Drive Your Career Forward
                            </h1>

                            <p className='paragraph text-white'>Join our network of professional instructors and help learners achieve their driving goals. </p>
                        </div>
                        {/* <div className='text-center'>
                            <img src={login_img} alt="" className='w-75' />
                        </div> */}

                    </div>
                    <div className="col-md-6 right-login-form pb-md-0 pb-5">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AccountContainer